import { BasicModel } from './basic.model';

export class PolicyHeader extends BasicModel<PolicyHeader> {
    accountNumber?: string;
    policyNumber?: string;
    policyType?: string;
    periodStart?: string;
    periodEnd?: string;
    clientName?: string;
    taxId?: string;
    officialIdType?: string;
}
